import * as PIXI from "pixi.js";
import { ControlConstants } from "../constant/ControlConstants";
import { AbstractPanelLayout } from "./AbstractPanelLayout";
/**
 * HorizontalLayout.ts
 */
export class HorizontalLayout extends AbstractPanelLayout {
    constructor(spacing, align = ControlConstants.LEFT, reverseOrder = false) {
        super();
        this.spacing = spacing;
        this.align = align;
        this.reverseOrder = reverseOrder;
    }
    equals(other) {
        return super.equals(other) &&
            (this.spacing === other.spacing) &&
            (this.width === other.width) &&
            (this.align === other.align) &&
            (this.reverseOrder === other.reverseOrder);
    }
    apply(children) {
        this.width = 0;
        let childrenReversed = children.slice().reverse();
        let child;
        let nextChild = this.reverseOrder ? childrenReversed[0] : children[0];
        let size;
        let nextSize;
        for (let i = 0; i < children.length - 1; i++) {
            child = this.reverseOrder ? childrenReversed[i] : children[i];
            nextChild = this.reverseOrder ? childrenReversed[i + 1] : children[i + 1];
            this.addChild(child, new PIXI.Point(this.width, 0));
            size = this.getChildSize(child);
            nextSize = this.getChildSize(nextChild);
            this.width += nextSize.x + (typeof this.spacing === "function" ? this.spacing(i) : this.spacing) + (size.x - nextSize.x) / 2;
        }
        if (nextChild) {
            this.addChild(nextChild, new PIXI.Point(this.width, 0));
        }
        this.applyAlignment();
    }
    applyAlignment() {
        if (this.align != ControlConstants.LEFT) {
            let panelSize = this.panel.getProperties().size;
            let panelWidth = panelSize ? panelSize.x : 0;
            let x = 0;
            this.holder.x = x;
            let xDiff = panelWidth - this.width;
            if (this.align == ControlConstants.CENTER) {
                x = xDiff / 2;
            }
            else if (this.align == ControlConstants.RIGHT) {
                x = xDiff;
            }
            this.holder.x = x;
        }
    }
    clone() {
        return new HorizontalLayout(this.spacing, this.align, this.reverseOrder);
    }
}
//# sourceMappingURL=HorizontalLayout.js.map